import { cn } from "@/lib/utils";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { sanityApi } from "@/features/sanity";

export default function Footer({ className }) {
  const navigate = useNavigate();
  const [cityPages, setCityPages] = useState([]);

  useEffect(() => {
    async function loadCityPages() {
      try {
        const pages = await sanityApi.fetchFooterCityPages();
        setCityPages(pages);
      } catch (error) {
        console.error("Failed to load city pages for footer", error);
      }
    }
    loadCityPages();
  }, []);

  return (
    <footer className={cn("footer bg-[#26385C] text-text-200 p-10", className)}>
      <aside>
        <img
          className="w-32 border-[1px] border-white"
          src="/Logos/Jakobs-Immobilien.jpg"
          alt="Jakobs Immobilien Logo"
        />
        <p className="text-text-200">
          Helga Jakobs Immobillien GmbH
          <br />
          Vertrauen über Generationen - seit 1978
        </p>
      </aside>
      <nav>
        <h3 className="footer-title">Leistungen</h3>
        <Link to={"/bewerten"} className="link link-hover">
          Bewerten
        </Link>
        <Link to={"/verkaufen"} className="link link-hover">
          Verkaufen
        </Link>
        <Link to={"/vermieten"} className="link link-hover">
          Vermieten
        </Link>
        <Link to={"/immobilien"} className="link link-hover">
          Immobilienangebot
        </Link>
      </nav>
      <nav>
        <h3 className="footer-title">Unternehmen</h3>
        <Link to={"/unternehmen/über-uns"} className="link link-hover">
          Über Uns
        </Link>
        <Link to={"/unternehmen/kontakt"} className="link link-hover">
          Kontakt
        </Link>
      </nav>
      <nav>
        <h3 className="footer-title">Standorte</h3>
        {cityPages.map((page) => (
          <Link
            key={page.slug.current}
            to={`/${page.slug.current}`}
            className="link link-hover"
          >
            {page.title}
          </Link>
        ))}
      </nav>
      <nav>
        <h3 className="footer-title">Rechtliches</h3>
        <Link to={"/rechtliches/impressum"} className="link link-hover">
          Impressum
        </Link>
        <Link to={"/rechtliches/datenschutz"} className="link link-hover">
          Datenschutz
        </Link>
      </nav>
    </footer>
  );
}
